// -----------------------------------------------------------------------------
// --- Global ------------------------------------------------------------------
// -----------------------------------------------------------------------------
const grey = {
    grey11: '#232830',
    grey10: '#343C47',
    grey9: '#424C5A',
    grey8: '#546072',
    grey7: '#657389',
    grey6: '#7F8C9F',
    grey5: '#9BA5B4',
    grey4: '#B5BDC8',
    grey3: '#D0D5DC',
    grey2: '#ECEEF1',
    grey1: '#F7F8F9'
};
const cambridgeBlue = {
    cambridgeBlue11: '#0D252D',
    cambridgeBlue10: '#133844',
    cambridgeBlue9: '#104E57',
    cambridgeBlue8: '#0D646A',
    cambridgeBlue7: '#098283',
    cambridgeBlue6: '#049F9D',
    cambridgeBlue5: '#00BDB6',
    cambridgeBlue4: '#4FD5C9',
    cambridgeBlue3: '#8EE8D8',
    cambridgeBlue2: '#D1F9F1',
    cambridgeBlue1: '#EEFEFA'
};
const river = {
    river11: '#10283C',
    river10: '#1B3955',
    river9: '#264E73',
    river8: '#306191',
    river7: '#3E7EBB',
    river6: '#5192D2',
    river5: '#7EB4E7',
    river4: '#A7CCF1',
    river3: '#C8E1F9',
    river2: '#E8F2FC',
    river1: '#F7FBFF'
};
const core = {
    black: '#000102',
    white: '#FEFFFE'
};
const globalColors = Object.assign(Object.assign(Object.assign(Object.assign({}, grey), cambridgeBlue), core), river);
const semanticColors = {
    'ui.background': globalColors.grey1,
    'ui.background-alt1': globalColors.grey1,
    'ui.background-alt2': globalColors.grey1,
    'ui.background-inverse': globalColors.grey1,
    'ui.overlay': globalColors.grey1,
    'ui.divider': globalColors.grey1,
    'ui.divider-alt1': globalColors.grey1,
    'ui.divider-inverse': globalColors.grey1,
    'ui.container': globalColors.grey1,
    'ui.container-hover': globalColors.grey1,
    'ui.container-focus': globalColors.grey1,
    'ui.container-active': globalColors.grey1,
    'ui.container-inverse': globalColors.grey1,
    'ui.container-inverse-hover': globalColors.grey1,
    'ui.container-inverse-focus': globalColors.grey1,
    'ui.container-inverse-active': globalColors.grey1,
    'feedback.info': globalColors.grey1,
    'interactive.primary': globalColors.grey1,
    'interactive.primary-hover': globalColors.grey1,
    'interactive.primary-active': globalColors.grey1,
    'interactive.primary-disabled': globalColors.grey1,
    'interactive.secondary': globalColors.grey1,
    'interactive.secondary-hover': globalColors.grey1,
    'interactive.secondary-active': globalColors.grey1,
    'interactive.secondary-disabled': globalColors.grey1,
    'interactive.tertiary': globalColors.grey1,
    'interactive.tertiary-hover': globalColors.grey1,
    'interactive.tertiary-active': globalColors.grey1,
    'interactive.tertiary-disabled': globalColors.grey1,
    'text.primary': globalColors.grey1,
    'text.secondary': globalColors.grey1,
    'text.helper': globalColors.grey1,
    'text.placeholder': globalColors.grey1,
    'text.inverse': globalColors.grey1,
    'text.link': globalColors.grey1,
    'text.link-hover': globalColors.grey1,
    'text.link-active': globalColors.grey1,
    'text.error': globalColors.grey1,
    'text.success': globalColors.grey1,
    'text.info': globalColors.grey1
};
// This needs to be generated automatically to avoid manually maintaining
// References are used for our Stitches theme to reference our css properties
const semanticColorsReferences = {
    'ui.background': '$grey1',
    'ui.background-alt1': '$grey1',
    'ui.background-alt2': '$grey1',
    'ui.background-inverse': '$grey1',
    'ui.overlay': '$grey1',
    'ui.divider': '$grey1',
    'ui.divider-alt1': '$grey1',
    'ui.divider-inverse': '$grey1',
    'ui.container': '$grey1',
    'ui.container-hover': '$grey1',
    'ui.container-focus': '$grey1',
    'ui.container-active': '$grey1',
    'ui.container-inverse': '$grey1',
    'ui.container-inverse-hover': '$grey1',
    'ui.container-inverse-focus': '$grey1',
    'ui.container-inverse-active': '$grey1',
    'feedback.info': '$grey1',
    'interactive.primary': '$grey1',
    'interactive.primary-hover': '$grey1',
    'interactive.primary-active': '$grey1',
    'interactive.primary-disabled': '$grey1',
    'interactive.secondary': '$grey1',
    'interactive.secondary-hover': '$grey1',
    'interactive.secondary-active': '$grey1',
    'interactive.secondary-disabled': '$grey1',
    'interactive.tertiary': '$grey1',
    'interactive.tertiary-hover': '$grey1',
    'interactive.tertiary-active': '$grey1',
    'interactive.tertiary-disabled': '$grey1',
    'text.primary': '$grey1',
    'text.secondary': '$grey1',
    'text.helper': '$grey1',
    'text.placeholder': '$grey1',
    'text.inverse': '$grey1',
    'text.link': '$grey1',
    'text.link-hover': '$grey1',
    'text.link-active': '$grey1',
    'text.error': '$grey1',
    'text.success': '$grey1',
    'text.info': '$grey1'
};

const fontFamilies = {
    mono: 'menlo, monospace',
    serif: 'Bitter, Georgia, serif',
    sans: 'Open Sans, -apple-system, system-ui, sans-serif'
};
const fontSizes = {
    '12px': '0.75em',
    '14px': '0.875em',
    '16px': '1em',
    '18px': '1.125em',
    '20px': '1.25em',
    '22px': '1.375em',
    '28px': '1.75em',
    '32px': '2em',
    '38px': '2.375em',
    '44px': '2.75em',
    '56px': '3.5em'
};
const lineHeights = {
    0: 1,
    1: 1.1,
    2: 1.2,
    3: 1.3,
    4: 1.4,
    5: 1.5,
    6: 1.6,
    7: 1.7,
    8: 1.8,
    9: 1.9
};
const letterSpacings = {
    '-2': '-0.2px',
    '-1': '-0.1px',
    0: '0px',
    1: '0.1px',
    2: '0.2px',
    3: '0.3px',
    4: '0.4px',
    5: '0.5px',
    6: '0.6px'
};
const fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
};
// -----------------------------------------------------------------------------
// --- Headings ----------------------------------------------------------------
// -----------------------------------------------------------------------------
/**
 * Heading 1 is used for the main heading of the page.
 */
const heading1 = {
    fontFamily: fontFamilies.serif,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes['32px'],
    lineHeight: lineHeights[7],
    letterSpacing: letterSpacings[0]
};
/**
 * Heading 2 is used for the secondary heading of the page.
 */
const heading2 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes['28px'],
    lineHeight: lineHeights[6],
    letterSpacing: letterSpacings[0]
};
/**
 * Heading 3 is used for the tertiary heading of the page.
 */
const heading3 = {
    fontFamily: fontFamilies.serif,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes['22px'],
    lineHeight: lineHeights[6],
    letterSpacing: letterSpacings[0]
};
/**
 * Heading 4 is used for the sub-heading of the page.
 */
const heading4 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.semibold,
    fontSize: fontSizes['18px'],
    lineHeight: lineHeights[5],
    letterSpacing: letterSpacings[0]
};
/**
 * Heading 5 is used for the sub-headings of the page.
 */
const heading5 = {
    fontFamily: fontFamilies.serif,
    fontWeight: fontWeights.semibold,
    fontSize: fontSizes['16px'],
    lineHeight: lineHeights[7],
    letterSpacing: letterSpacings[0]
};
/**
 * Heading 6 is used for the sub-headings of the page.
 */
const heading6 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.bold,
    fontSize: fontSizes['14px'],
    lineHeight: lineHeights[9],
    letterSpacing: letterSpacings[0],
    fontFeatureSettings: '"tnum" on , "lnum" on'
};
// -----------------------------------------------------------------------------
// --- Display -----------------------------------------------------------------
// -----------------------------------------------------------------------------
/**
 * Display 1 is used for the main visual text of the page.
 */
const display1 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.light,
    fontSize: fontSizes['56px'],
    lineHeight: lineHeights[2],
    letterSpacing: letterSpacings[0]
};
const display2 = {
    fontFamily: fontFamilies.serif,
    fontWeight: fontWeights.light,
    fontSize: fontSizes['44px'],
    lineHeight: lineHeights[5],
    letterSpacing: letterSpacings[0]
};
const display3 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.light,
    fontSize: fontSizes['38px'],
    lineHeight: lineHeights[5],
    letterSpacing: letterSpacings[0]
};
// -----------------------------------------------------------------------------
// --- Paragraph ---------------------------------------------------------------
// -----------------------------------------------------------------------------
const paragraph1 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes['20px'],
    lineHeight: lineHeights[9],
    letterSpacing: letterSpacings[0],
    fontFeatureSettings: '"tnum" on , "lnum" on'
};
const paragraph2 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes['18px'],
    lineHeight: lineHeights[9],
    letterSpacing: letterSpacings[0],
    fontFeatureSettings: '"pnum" on , "lnum" on'
};
const paragraph3 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes['16px'],
    lineHeight: lineHeights[7],
    letterSpacing: letterSpacings[0],
    fontFeatureSettings: '"tnum" on , "lnum" on'
};
const paragraph4 = {
    fontFamily: fontFamilies.sans,
    fontWeight: fontWeights.regular,
    fontSize: fontSizes['14px'],
    lineHeight: lineHeights[7],
    letterSpacing: letterSpacings[0],
    fontFeatureSettings: '"tnum" on , "lnum" on'
};
const typeStyles = {
    headings: {
        heading1,
        heading2,
        heading3,
        heading4,
        heading5,
        heading6
    },
    display: {
        display1,
        display2,
        display3
    },
    paragraph: {
        paragraph1,
        paragraph2,
        paragraph3,
        paragraph4
    }
};

const spacing = {
    '2px': '2px',
    '4px': '4px',
    '8px': '8px',
    '12px': '12px',
    '16px': '16px',
    '20px': '20px',
    '24px': '24px',
    '32px': '32px',
    '40px': '40px',
    '64px': '64px',
    '80px': '80px',
    '96px': '96px',
    '120px': '120px'
};

const radii = {
    '4px': '4px',
    '16px': '16px',
    '32px': '32px',
    pill: '9999px'
};

const zIndices = {
    1: '100',
    2: '200',
    3: '300',
    4: '400',
    5: '500',
    6: '600',
    7: '700',
    8: '800',
    9: '900',
    max: '999'
};

export { globalColors as colours, fontFamilies, fontSizes, fontWeights, letterSpacings, lineHeights, radii, semanticColors, semanticColorsReferences, spacing, typeStyles, zIndices };
